const Login = () => import(/* webpackChunkName: "exoty" */ './view/login.vue');
const LoginVerify = () => import(/* webpackChunkName: "exoty" */ './view/verify.vue');

export const ROUTE_NAME_LOGIN = {
    INDEX: 'Login',
    VERIFY: 'LoginVerify'
} as const;

export default [
    {
        path: '/login',
        name: ROUTE_NAME_LOGIN.INDEX,
        component: Login,
        meta: { requiresUnauth: true }
    },
    {
        path: '/login/verify',
        name: ROUTE_NAME_LOGIN.VERIFY,
        component: LoginVerify,
        meta: { requiresAuth: true }
    }
];
